import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import {
  Policy as CafeIcon,
  GppMaybe as RiskIcon,
  ManageSearch as FalconIcon,
  Security as SecurityIcon,
} from '@mui/icons-material';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import { useFeature } from '../EnvironmentContext';
import PageSkeleton from './PageSkeleton';
import IamAgentLogo from './IamAgentLogo';

const helpdeskTabs = [
  { label: 'CA Failure Examiner', path: '/helpdesk/cafe', icon: <CafeIcon /> },
  { label: 'Risky User Report', path: '/helpdesk/risk', icon: <RiskIcon /> },
  { label: 'Auth Method Changes', path: '/helpdesk/falcon', icon: <FalconIcon /> },
  { label: 'Auth Methods', path: '/helpdesk/phish', icon: <SecurityIcon /> },
];

const HelpdeskLayout: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const sreAgentEnabled = useFeature('Operations.SreAgentRead');
  const visibleTabs = sreAgentEnabled
    ? [...helpdeskTabs, { label: 'IAM Agent Assistant', path: '/iam-agent-assistant', icon: <IamAgentLogo /> }]
    : helpdeskTabs;

  const currentTab = visibleTabs.findIndex((tab) =>
    tab.path === '/helpdesk/cafe'
      ? location.pathname === '/helpdesk' || location.pathname === '/helpdesk/cafe'
      : location.pathname.startsWith(tab.path),
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', flexShrink: 0 }}>
        <Tabs
          value={currentTab === -1 ? 0 : currentTab}
          onChange={(_, newValue) => navigate(visibleTabs[newValue].path)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ minHeight: 42 }}
        >
          {visibleTabs.map((tab) => (
            <Tab
              key={tab.path}
              icon={tab.icon}
              iconPosition="start"
              label={tab.label}
              sx={{ minHeight: 42, py: 0, textTransform: 'none', fontSize: '0.85rem' }}
            />
          ))}
        </Tabs>
      </Box>
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        {/* Keeps this section's tab bar on screen while the next tab's chunk loads. */}
        <React.Suspense fallback={<PageSkeleton />}>
          <Outlet />
        </React.Suspense>
      </Box>
    </Box>
  );
};

export default HelpdeskLayout;
